export const getStyledConfig = (props: string | readonly string[] | string[]) => ({
  shouldForwardProp: (propName: string | number) => {
    const propsList = Array.isArray(props) ? props : [props]

    return propsList.every((item) => item !== propName)
  },
})
